import { FormControl, FormGroup } from "@angular/forms";
import { SearchModelV2 } from "../../../../models/search-model-v2";

/**
 * Search model for the permission-wizard target picker (companies, branches or
 * locations, depending on the template).
 *
 * Converted from the legacy SearchModel. The raw SQL it used to carry:
 *
 *   query:  (q) => q
 *     ? `(hdr.code ILIKE '%q%' OR hdr.name ILIKE '%q%' AND hdr.status = 'ACTIVE')`
 *     : ''
 *   table:  set at runtime from TARGET_TABLES
 *   queryCallbacks: {
 *     code: c => `hdr.code ILIKE '%c%'`,
 *     name: n => `hdr.name ILIKE '%n%'`
 *   }
 *   additionalCondition: ` AND hdr.status = 'ACTIVE'`
 *
 * The component maps those onto criteria that CompanyUow, BranchUow and
 * LocationUow all understand: the keyword onto `search_word` (each ILIKEs code
 * and name), the two fields onto `code_like` / `name_like`, and the scoping onto
 * `status = 'ACTIVE'`. The target table no longer has to be carried in the model
 * because the component already picks the matching service.
 */
export const targetSearchModel: SearchModelV2 = {
    label: {
        code: "Code",
        name: "Name",
    },
    dataType: {
        code: "string",
        name: "string",
    },
    form: new FormGroup({
        code: new FormControl(),
        name: new FormControl(),
    }),
    options: {
        code: {},
        name: {},
    },
};


export const TARGET_TABLES = {
    COMP: "bl_fi_mst_comp",
    BRANCH: "bl_fi_mst_branch",
    LOCATION: "bl_inv_mst_location"
}
